import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
} from "@mui/material";
import { THEMES } from "../../constants";
import useTheme from "../../hooks/useTheme";
import { Palette } from "@mui/icons-material";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Flag = styled.img`
  border-radius: 50%;
  width: 22px;
  height: 22px;
`;

type themeOptionsType = {
  [key: string]: {
    img: string;
    name: string;
    theme: any;
  };
};

const themeOptions: themeOptionsType = {
  default: {
    img: "default",
    name: "Default",
    theme: THEMES.DEFAULT,
  },
  dark: {
    img: "dark",
    name: "Dark",
    theme: THEMES.DARK,
  },
  light: {
    img: "light",
    name: "Light",
    theme: THEMES.LIGHT,
  },
  blue: {
    img: "blue",
    name: "Blue",
    theme: THEMES.BLUE,
  },
  green: {
    img: "green",
    name: "Green",
    theme: THEMES.GREEN,
  },
  indigo: {
    img: "indigo",
    name: "Indigo",
    theme: THEMES.INDIGO,
  },
  red: {
    img: "red",
    name: "Red",
    theme: THEMES.RED,
  },
  deepPurple: {
    img: "deepPurple",
    name: "Deep Purple",
    theme: THEMES.DEEP_PURPLE,
  },
  yellow: {
    img: "yellow",
    name: "Yellow",
    theme: THEMES.YELLOW,
  },
  black: {
    img: "black",
    name: "Black",
    theme: THEMES.BLACK,
  },
};

function NavbarThemesDropdown() {
  const { t, i18n } = useTranslation();
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);

  const { setTheme } = useTheme();

  const selectedTheme = themeOptions[i18n.language];

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleThemeChange = (theme: string) => {
    setTheme(themeOptions[theme].theme);
    closeMenu();
  };

  return (
    <React.Fragment>
      <Tooltip title={t("Change theme")}>
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <Palette />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        {Object.keys(themeOptions).map((themeOption) => (
          <MenuItem
            key={themeOption}
            onClick={() => handleThemeChange(themeOption)}
          >
            {t(themeOptions[themeOption].name)}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}

export default NavbarThemesDropdown;
